import { Alert, Button, Modal, ModalHeader, ModalBody } from "flowbite-react";
import type { FC } from "react";
import { useState } from "react";
import { HiExclamation } from "react-icons/hi";
import type { ContractType } from "../../services/contract-types";
import { deleteContractType } from "../../services/contract-types";

interface DeleteConfirmationModalProps {
  contractType: ContractType;
  show: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  contractType,
  show,
  onClose,
  onConfirm,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    setIsDeleting(true);
    setError(null);
    try {
      const result = await deleteContractType(contractType.id);
      if (result.success) {
        await onConfirm();
        onClose();
      } else {
        setError(result.error || "Fehler beim Löschen des Vertragstyps");
      }
    } catch (error) {
      setError(
        error instanceof Error
          ? error.message
          : "Fehler beim Löschen des Vertragstyps"
      );
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal show={show} size="md" onClose={onClose} popup>
      <ModalHeader />
      <ModalBody>
        <div className="text-center">
          <HiExclamation className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
          <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
            Möchten Sie den Vertragstyp "{contractType.type}" wirklich löschen?
          </h3>
          {error && (
            <Alert color="failure" className="mb-4">
              {error}
            </Alert>
          )}
          <div className="flex justify-center gap-4">
            <Button
              color="failure"
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? "Wird gelöscht..." : "Ja, löschen"}
            </Button>
            <Button color="gray" onClick={onClose}>
              Nein, abbrechen
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
